import { ImageHistoryDetailModel } from './image.history.detail.model';
export class PagedImageHistoryDetails {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: ImageHistoryDetailModel[] = [];
}
